import { z } from 'zod';

export const ServiceTypeSchema = z
    .object({
        id: z.string(),
        name: z.string(),
    })
    .partial()

export type ServiceType = z.TypeOf<typeof ServiceTypeSchema>;